export default "__VITE_ASSET__DjhJGqFt__"